import { render, staticRenderFns } from "./form-point-form.vue?vue&type=template&id=e81bc664"
import script from "./form-point-form.vue?vue&type=script&lang=js"
export * from "./form-point-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports